//#region IMPORT
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import dayjs from 'dayjs';
import { ExcelGridCommon } from '../../../../Components/ExcelGridCommon';
import ExcelUploadCommon from '../../../../Components/ExcelUploadCommon/ExcelUploadCommon';
import { getColumnDefs1 } from './PPE_BASIC_02_ColumnDefs';
//#endregion

function PPE_BASIC_02(props) {
  const searchInfo = useSelector((state) => state.SearchInfo);

  // 보호구 관리대장 그리드 컬럼
  const columnDefs1 = getColumnDefs1(props);

  //#region AuthButton 이벤트
  useEffect(() => {
    // 현재 탭이 1번이 아닌 경우 처리하지 않음
    if (props.value !== 1) return;

    if (props.filterClick2) {
      if (!props.validateSelection()) {
        props.setFilterClick2(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick2(false);
    }
    if (props.searchClick2) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick2(false);
        return;
      }

      props.SearchLogic1();
      props.setSearchClick2(false);
    }
    if (props.addClick2) {
      if (!props.validateSelection()) {
        props.setAddClick2(false);
        return;
      }

      props.setAddClick2(false);
    }
    if (props.saveClick2) {
      if (!props.validateSelection()) {
        props.setSaveClick2(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick2(false);
    }
    if (props.printClick2) {
      if (!props.validateSelection()) {
        props.setPrintClick2(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick2(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.value,
    props.filterClick2,
    props.searchClick2,
      props.addClick2,
      props.saveClick2,
      props.printClick2,
  ]);
  //#endregion

  useEffect(() => {
    if (props.readyToExport && props.gridRef2.current) {
      props.gridRef2.current.api.exportDataAsExcel({
        fileName: dayjs().format('YYYYMMDDHHmm') + '보호구관리대장.xlsx',
      });
      props.setReadyToExport(false); // 여러 번 클릭 방지
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.readyToExport]);
  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        addClick1={() => {
          if (!props.validateSelection()) return;

          // 그룹 행 추가
          const newGroupRow = {
            no: Date.now(),
            group: '',
            isGroupRow: true,
            isExpanded: true, // 기본값: 펼침
            showAddSubButton: false,
            newYn: 'Y',
            equipNm: '',
            gubun: '',
            unit: '',
            spec: '',
            paymentStandard: null,
            price: null,
            moveDate: null,
            inDate: null,
            inQty: null,
            outDate: null,
            outQty: null,
            currentQty: null,
            reason: '',
            managerDepartment: '',
            managerId: '',
            remark: '',
          };

          // originalRowData1에 추가하고 필터링
          const currentOriginalData = [...(props.originalRowData1 || [])];
          currentOriginalData.push(newGroupRow);
          props.setOriginalRowData1?.(currentOriginalData);

          // 필터링된 데이터 업데이트
          const filteredData =
            props.filterExpandedRows?.(currentOriginalData) ||
            currentOriginalData;
          props.setRowData1(filteredData);
          props.setChangedRowData1((prev) => [...prev, newGroupRow]);
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        addYn1="N"
        deleteYn1="N"
        title1={'보호구 관리대장'}
        gridRef={props.gridRef1}
        editable={true}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        rowSelection={'none'}
        onCellValueChanged={(e) => {
          if (!e.data || e.data.isGroupRow) return;

          // 구분 필드가 변경될 때 입고/출고 필드 초기화
          if (e.colDef.field === 'gubun') {
            const gridApi = props.gridRef1.current.api;
            const rowNode = gridApi.getRowNode(e.data.no);

            if (e.newValue === '입고') {
              rowNode.setDataValue('outDate', null);
              rowNode.setDataValue('outQty', null);
            } else if (e.newValue === '출고') {
              rowNode.setDataValue('inDate', null);
              rowNode.setDataValue('inQty', null);
            }

            const updatedData = { ...e.data };
            if (e.newValue === '입고') {
              updatedData.outDate = null;
              updatedData.outQty = null;
            } else if (e.newValue === '출고') {
              updatedData.inDate = null;
              updatedData.inQty = null;
            }

            if (props.originalRowData1 && props.setOriginalRowData1) {
              const currentOriginalData = [...props.originalRowData1];
              const originalIndex = currentOriginalData.findIndex(
                (row) => row.no === updatedData.no
              );
              if (originalIndex !== -1) {
                currentOriginalData[originalIndex] = updatedData;
                props.setOriginalRowData1(currentOriginalData);
                const filteredData =
                  props.filterExpandedRows?.(currentOriginalData) ||
                  currentOriginalData;
                props.setRowData1(filteredData);
              }
            }

            props.setChangedRowData1((prev) => {
              const filtered = prev.filter(
                (item) => item.no !== updatedData.no
              );
              return [...filtered, updatedData];
            });
            return;
          }

          // 입고일자·입고수량·출고일자·출고수량 등 변경 시 새로 추가된 행이면 changedRowData1에 반영
          if (e.data.newYn === 'Y') {
            const updatedData = { ...e.data };
            props.setChangedRowData1((prev) => {
              const filtered = prev.filter(
                (item) => item.no !== updatedData.no
              );
              return [...filtered, updatedData];
            });
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.setSelectedRowData1(selectedData);
        }}
      />
      <ExcelGridCommon
        gridRef={props.gridRef2}
        rowData={props.excelData}
        columnDefs={columnDefs1}
        rowSelection="multiple"
      />
      <ExcelUploadCommon
        fileInputRef={props.fileInputRef}
        gridRef={props.gridRef1}
        rowData={props.rowData1}
        columnDefs={columnDefs1}
        setChangedRowData={props.setChangedRowData1}
      />
    </React.Fragment>
  );
}

export default PPE_BASIC_02;
